import { render, staticRenderFns } from "./add-rise.vue?vue&type=template&id=506a1d92&scoped=true&"
import script from "./add-rise.vue?vue&type=script&lang=js&"
export * from "./add-rise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a1d92",
  null
  
)

export default component.exports